import * as React from "react";
import { Action, IOWidget, mk_widget, Pair } from "widgets-for-react";
import { Link, CMSState, ImageSize } from "../../../../cms/blocks/types.gen";
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { toRelativeUrl } from "../../../../../helpers";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type QuoteBlockProps<extra_images> = {
  index: number
  text: string
  author?: string
  company?: string
  primary_button?: Link | null
  secondary_button?: Link | null
  image?: WordPress.MediaResponse
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type QuoteBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function QuoteBlock<customBlockData, extra_images>(
  props: QuoteBlockProps<extra_images>,
  options?: { style?: QuoteBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => {
        // const hasImage = props.image && props.image.media_details.sizes['quote-l'];
        const hasImage = props.image;
        return (
          <section className={`block block--quote quote--${hasImage ? 'image' : 'text'}`}
            key={options && options.key ? options.key : `block-${props.index}`}
          >
            <div className="block__inner container container--m gutter--m spacing--m">
              <div className={`block__content${hasImage ? ' ls-first-item' : ''}`}>
                <blockquote className="block__quote ff--primary">
                  <p dangerouslySetInnerHTML={{__html: props.text}} />
                </blockquote>
                {(props.author || props.company) && <figcaption className="block__caption typo--ms fw--light"><span>{props.author}</span>{props.author && props.company && ","} <span>{props.company}</span></figcaption>}
                {(props.primary_button || props.secondary_button) &&              
                  <footer className="block__footer ls-clickables">
                    {props.primary_button && (
                      link(linkWrapper({title:props.primary_button.title,url:props.primary_button.url}),
                        { classname: 'button button--primary ls-clickable' },
                        props.primary_button.title
                        ) 
                    )}
                    {props.secondary_button && (
                      link(linkWrapper({title:props.secondary_button.title,url:props.secondary_button.url}),
                        { classname: 'button button--secondary ls-clickable' },
                        props.secondary_button.title
                        )
                    )}
                  </footer>
                }
              </div>
              {hasImage &&
                <div className="block__visual ls-second-item">
                  <img
                     src='/frontend/images/empty.png'
                     width={getImageAttribute(props.image, 'quote-s', 'width')}
                     height={getImageAttribute(props.image, 'quote-s', 'height')}
                     className="block__image border-radius--s lazyload"
                     alt={props.image.alt_text ? props.image.alt_text : ''}
                     data-sizes="auto"
                     data-src={getImageAttribute(props.image, 'quote-s', 'source_url')}
                     data-srcset={`${getImageAttribute(props.image, 'quote-s', 'source_url')} 600w,
                     ${getImageAttribute(props.image, 'quote-m', 'source_url')} 1200w,
                     ${getImageAttribute(props.image, 'quote-l', 'source_url')} 1800w`}
                  />
                </div>}
            </div>
          </section>
        )
      },
    })
}
